export const PREPARE_SCOPE_STATE_COPY = 'PREPARE_SCOPE_STATE_COPY';
export const ROLLBACK_SCOPE_STATE = 'ROLLBACK_SCOPE_STATE';
